import { lazyNamed } from 'src/utils/lazyNamed.ts';

const PrintOperations = {
  Helmet: lazyNamed(() => import('./components/Helmet.tsx'), 'Helmet'),
  Print: lazyNamed(() => import('./containers/Print/index.tsx'), 'Print'),
  PublicationUpload: lazyNamed(() => import('./containers/PublicationUpload/index.tsx'), 'PublicationUpload'),
};

export default PrintOperations;
